import dayjs from "dayjs";

export function formatDate(date: Date | undefined): string {
    return date
        ? dayjs(date).format('DD. MMM (HH:mm)')
        : '';
}
